import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import Currencies from '../../../../../utils/Currencies';
import PriceBreakdown from 'arbitrip-common/client/utils/PriceBreakdown';
import DealDisclaimer from '../DealDisclaimer';

function DealPricePerNight({
    deal,
    profile,
    nights,
    rooms,
    expediaTotalPriceAfterDiscount,
    totalPriceAfterDiscount,
    isPrivateTravelOnly,
}) {
    const { t } = useTranslation();

    if (PriceBreakdown.isBreakdownPrice({ profile, deal })) {
        return (
            <div className="deal-price-per-night">
                {nights > 1 && (expediaTotalPriceAfterDiscount > 0 || isPrivateTravelOnly) && (
                    <>
                        {isPrivateTravelOnly ? (
                            <div>
                                <Trans
                                    i18nKey={nights > 1 ? 'PriceForNight_other' : 'PriceForNight_one'}
                                    count={nights}
                                    components={{ span: <span className="nights-bold" /> }}
                                />
                            </div>
                        ) : (
                            <div>
                                <span className="price">
                                    {Currencies.getPriceWithDisplayCurrencyByPrecision(
                                        expediaTotalPriceAfterDiscount / nights / rooms,
                                        profile.display_currency_exchange_rate,
                                        profile.display_currency,
                                        0,
                                    )}
                                </span>
                                {t('AvgRoomNight')}
                            </div>
                        )}
                    </>
                )}
                <div>{t('IncludesTaxesAndFees')}</div>
            </div>
        );
    }

    if (PriceBreakdown.isShowTotalPrice({ profile })) {
        return (
            <div className="deal-price-per-night">
                {nights > 1 && (totalPriceAfterDiscount > 0 || isPrivateTravelOnly) && (
                    <>
                        {isPrivateTravelOnly ? (
                            <div>
                                <Trans
                                    i18nKey="PriceForNight"
                                    count={nights}
                                    components={{ span: <span className="nights-bold" /> }}
                                />
                            </div>
                        ) : (
                            <div>
                                <span className="price">
                                    {Currencies.getPriceWithDisplayCurrencyByPrecision(
                                        totalPriceAfterDiscount / nights / rooms,
                                        profile.display_currency_exchange_rate,
                                        profile.display_currency,
                                        0,
                                    )}
                                </span>
                                {t('AvgRoomNight')}
                            </div>
                        )}
                    </>
                )}
                <DealDisclaimer deal={deal} />
            </div>
        );
    }

    return <div className="per-night-text">{t('PerNight')}</div>;
}

DealPricePerNight.propTypes = {
    deal: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    nights: PropTypes.number.isRequired,
    rooms: PropTypes.number,
    expediaTotalPriceAfterDiscount: PropTypes.number,
    totalPriceAfterDiscount: PropTypes.number,
    isPrivateTravelOnly: PropTypes.bool,
};

export default DealPricePerNight;
